import { Box, Grid, useMediaQuery, useTheme } from '@mui/material';
import { DashboardTransactionsTable } from './transactions/DashboardTransactionsTable';
import { StationsAndConnectorsCardChart } from './charts/StationsAndConnectorsCardChart';
import { DashboardLocationMap } from './maps/DashboardLocationMap';
import { DashboardWidgetContainer } from './widgets/DashboardWidgetContainer';

export const Dashboard = () => {
  const theme = useTheme();
  const isSmallerThanLXLScreen = useMediaQuery(theme.breakpoints.down('xl'));

  return (
    <>
      <Box
        sx={{
          paddingBottom: 6,
          display: 'flex',
          flexDirection: 'column',
          gap: 6,
          marginTop: -3.5,
        }}
      >
        <Grid container spacing={6}>
          <DashboardWidgetContainer />
          <Grid item xl={6} lg={12} md={12} sm={12} xs={12}>
            <Box pt={3}>
              <DashboardLocationMap />
            </Box>
          </Grid>
        </Grid>

        <Grid item container xs={12}>
          <StationsAndConnectorsCardChart />
        </Grid>
      </Box>

      <Grid
        item
        xs={12}
        sx={{
          display: 'flex',
          flex: 1,
          minHeight: isSmallerThanLXLScreen ? '600px' : 'unset',
        }}
      >
        <DashboardTransactionsTable />
      </Grid>
    </>
  );
};
